import { Currency, PaymentTerm } from '../../common';
import { ProjectType } from './project-type';

export interface Project {
  projectId: number;
  projectCode: string;
  projectDesc: string;

  projectType: ProjectType;

  customer: {
    customerId: number,
    customerCode: string,
    customerDesc: string,
  };

  paymentTerm?: PaymentTerm;

  purchaseOrder?: {
    isValidable: true,
  };

  currency?: Currency;
}
